import OlvidoContrasenaCard from "components/OlvidoContrasenaCard";
import "./styles.css";

const OlvidoContrasena = () => {
  return (
    <div className="login-page-container">
      <OlvidoContrasenaCard />
    </div>
  );
};

export default OlvidoContrasena;
